import type { ThemeDefinition } from "vuetify"

const DARK_BLUE_THEME: ThemeDefinition = {
  dark: true,
  variables: {
    "border-color": "#333F55",
    "border-opacity": 1,
  },
  colors: {
    primary: "#186dde",
    secondary: "#0acc95",
    info: "#7460ee",
    success: "#13DEB9",
    accent: "#fc4b6c",
    warning: "#fec90f",
    error: "#ef5350",
    lightprimary: "#253662",
    lightsecondary: "#1C455D",
    lightsuccess: "#1B3C48",
    lighterror: "#4B313D",
    lightwarning: "#4D3A2A",
    lightinfo: "#223662",
    textPrimary: "#EAEFF4",
    textSecondary: "#7C8FAC",
    borderColor: "#1d1d1d",
    inputBorder: "#465670",
    containerBg: "#171c23",
    background: "#171c23",
    hoverColor: "#333f55",
    surface: "#171c23",
    "on-surface-variant": "#171c23",
    grey100: "#333F55",
    grey200: "#465670",
    muted: "#171c23",
    borderline: "#1d1d1d",
  },
}

const DARK_AQUA_THEME: ThemeDefinition = {
  dark: true,
  variables: {
    "border-color": "#333F55",
    "border-opacity": 1,
  },
  colors: {
    primary: "#0074BA",
    secondary: "#47D7BC",
    info: "#7460ee",
    success: "#13DEB9",
    accent: "#fc4b6c",
    warning: "#fec90f",
    error: "#ef5350",
    lightprimary: "#103247",
    lightsecondary: "#0C4339",
    lightsuccess: "#1B3C48",
    lighterror: "#4B313D",
    lightwarning: "#4D3A2A",
    lightinfo: "#223662",
    textPrimary: "#EAEFF4",
    textSecondary: "#7C8FAC",
    borderColor: "#1d1d1d",
    inputBorder: "#465670",
    containerBg: "#171c23",
    background: "#171c23",
    hoverColor: "#333f55",
    surface: "#171c23",
    "on-surface-variant": "#171c23",
    grey100: "#333F55",
    grey200: "#465670",
    muted: "#171c23",
    borderline: "#1d1d1d",
  },
}

const DARK_PURPLE_THEME: ThemeDefinition = {
  dark: true,
  variables: {
    "border-color": "#333F55",
    "border-opacity": 1,
  },
  colors: {
    primary: "#763EBD",
    secondary: "#95CFD5",
    info: "#7460ee",
    success: "#13DEB9",
    accent: "#fc4b6c",
    warning: "#fec90f",
    error: "#ef5350",
    lightprimary: "#26153C",
    lightsecondary: "#09454B",
    lightsuccess: "#1B3C48",
    lighterror: "#4B313D",
    lightwarning: "#4D3A2A",
    lightinfo: "#223662",
    textPrimary: "#EAEFF4",
    textSecondary: "#7C8FAC",
    borderColor: "#1d1d1d",
    inputBorder: "#465670",
    containerBg: "#171c23",
    background: "#171c23",
    hoverColor: "#333f55",
    surface: "#171c23",
    "on-surface-variant": "#171c23",
    grey100: "#333F55",
    grey200: "#465670",
    muted: "#171c23",
    borderline: "#1d1d1d",
  },
}

const DARK_GREEN_THEME: ThemeDefinition = {
  dark: true,
  variables: {
    "border-color": "#333F55",
    "border-opacity": 1,
  },
  colors: {
    primary: "#0A7EA4",
    secondary: "#CCDA4E",
    info: "#7460ee",
    success: "#13DEB9",
    accent: "#fc4b6c",
    warning: "#fec90f",
    error: "#ef5350",
    lightprimary: "#05313F",
    lightsecondary: "#282917",
    lightsuccess: "#1B3C48",
    lighterror: "#4B313D",
    lightwarning: "#4D3A2A",
    lightinfo: "#223662",
    textPrimary: "#EAEFF4",
    textSecondary: "#7C8FAC",
    borderColor: "#1d1d1d",
    inputBorder: "#465670",
    containerBg: "#171c23",
    background: "#171c23",
    hoverColor: "#333f55",
    surface: "#171c23",
    "on-surface-variant": "#171c23",
    grey100: "#333F55",
    grey200: "#465670",
    muted: "#171c23",
    borderline: "#1d1d1d",
  },
}

const DARK_CYAN_THEME: ThemeDefinition = {
  dark: true,
  variables: {
    "border-color": "#333F55",
    "border-opacity": 1,
  },
  colors: {
    primary: "#01C0C8",
    secondary: "#FB9678",
    info: "#7460ee",
    success: "#13DEB9",
    accent: "#fc4b6c",
    warning: "#fec90f",
    error: "#ef5350",
    lightprimary: "#003638",
    lightsecondary: "#40241C",
    lightsuccess: "#1B3C48",
    lighterror: "#4B313D",
    lightwarning: "#4D3A2A",
    lightinfo: "#223662",
    textPrimary: "#EAEFF4",
    textSecondary: "#7C8FAC",
    borderColor: "#1d1d1d",
    inputBorder: "#465670",
    containerBg: "#171c23",
    background: "#171c23",
    hoverColor: "#333f55",
    surface: "#171c23",
    "on-surface-variant": "#171c23",
    grey100: "#333F55",
    grey200: "#465670",
    muted: "#171c23",
    borderline: "#1d1d1d",
  },
}

const DARK_ORANGE_THEME: ThemeDefinition = {
  dark: true,
  variables: {
    "border-color": "#333F55",
    "border-opacity": 1,
  },
  colors: {
    primary: "#FA896B",
    secondary: "#0074BA",
    info: "#7460ee",
    success: "#13DEB9",
    accent: "#fc4b6c",
    warning: "#fec90f",
    error: "#ef5350",
    lightprimary: "#402E32",
    lightsecondary: "#082E45",
    lightsuccess: "#1B3C48",
    lighterror: "#4B313D",
    lightwarning: "#4D3A2A",
    lightinfo: "#223662",
    textPrimary: "#EAEFF4",
    textSecondary: "#7C8FAC",
    borderColor: "#1d1d1d",
    inputBorder: "#465670",
    containerBg: "#171c23",
    background: "#171c23",
    hoverColor: "#333f55",
    surface: "#171c23",
    "on-surface-variant": "#171c23",
    grey100: "#333F55",
    grey200: "#465670",
    muted: "#171c23",
    borderline: "#1d1d1d",
  },
}

export { DARK_BLUE_THEME, DARK_AQUA_THEME, DARK_ORANGE_THEME, DARK_PURPLE_THEME, DARK_GREEN_THEME, DARK_CYAN_THEME }
